import React, { Component } from 'react';
import './css/Actividad.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Col, Row, Container } from 'react-bootstrap';
import crear from './../img/svg/Nueva.svg';
import enviar from './../img/svg/Enviar(blanco).svg';
import { Solicitud_materia } from './expand/Solicitud_materia';

const API_URL = process.env.REACT_APP_API_URL;
function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '15%', fontSize: 11,
    };
} function color_head_desc(tipo) {
    if (tipo == 'a') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '50%'
        };
    } else if (tipo == 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        }
    } else if (tipo == 'id') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '15%'
        };
    } else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}

function estaConformeFormatter(column, colIndex, { sortElement, filterElement }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '60px' }}>
            { filterElement}
            { column.text}
            { sortElement}
        </div>
    );

}

function PaoFormatter(cell, row) {
    switch (row.termino) {
        case "1ER TERMINO":
            return (
                <span>PAO-1</span>
            );
            break;
        case "2DO TERMINO":
            return (
                <span>PAO-2</span>
            );
            break;
        case "3ER TERMINO":
            return (
                <span>PAE</span>
            );
            break;
        default:
            return (
                <span>{cell}</span>
            );
            break;
    }
}


export class Admision_out extends Component {
    static displayName = Admision_out.name;

    handleBtnClick_mat = () => {
        if (!this.state.expanded_mat.includes(0)) {
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, 0]
            }));
        } else {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== 0)
            }));

        }
    }

    handleOnExpand_mat = (row, isExpand, rowIndex, e) => {
        if (isExpand) {
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, row.id]
            }));
        } else {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== row.id)
            }));
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            actividades: [], solicitudes: [],busqueda: "", actividad: {
                idactividad: 0, actividad: "", tipoactividad: 0, descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino1: "", termino2: "", termino3: "", periodicidad: "", totalhoras: 0, estadocheck: "", escarga: ""
            }, materias: [], materia: {
                idcurso: 0, porc: 0, anio: "", term: "", termino: "", codigomateria: "", nommateria: "", numhorasteoricas: 0, numhoraspracticas: 0, paralelo: 0, idtipoactividad: 0,
                observacion: "", fechaInicio: "", fechaFin: "", valorevaluacion: 0, valornumexam: 0, estadocheck: "", tipoprofesor: ""
            }, loading: false, loading2: false, total: 0, selectact: "", selectidact: "", abierto: false,
            materia_elegida: [
                { idcurso: 0, validada: "", estado_actividad: "" }
            ],
            actividad_elegida: [
                { idactividad: 0, validada: "", estado_actividad: "" }
            ],
            anio: props.anio, idpersona: props.idprof, actividades_combo: [], periodo: "", newactividad: "", observacion: "", expanded_mat: [],
            fila_mat: [], selectact: "", selectidact: "", abierto: false
        };



        this.onChangePao = this.onChangePao.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleNew = this.handleNew.bind(this);

        this.updatestate_mat = this.updatestate_mat.bind(this);
    }

    componentDidMount() {
        if (this.state.anio > 0) {  
            this.populateMateriasData(this.props.idprof, this.props.anio);
            this.populateActividadesCombo(this.props.idprof, this.props.anio);
        }
    }

    updatestate_mat(idcurso, descripcion, observacion, anio, termino, totalhoras, accion) {
        var solicitudes = this.state.solicitudes
        if (solicitudes.length == 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad != idcurso)
        }

        solicitudes.push({
            idactividad: idcurso, descripcion: descripcion, observacion: observacion, anio: anio, pao1: termino, pao2: termino, pae: termino, totalhoras: totalhoras, termino: termino, accion: accion
        })
        this.setState({
            solicitudes: solicitudes
        });

        this.props.update({ ambito: 'A|A', idactividad: idcurso, descripcion: descripcion, observacion: observacion, anio: anio, pao1: termino, pao2: termino, pae: termino, tipoactividad: 'AD', totalhoras: totalhoras, termino: termino, accion: accion})
        //console.log(JSON.stringify(this.state.solicitudes))
    }

    abrirModal = () => {
        this.setState({ abierto: !this.state.abierto });
    }

    cerrarModal = () => {
        this.setState({ abierto: false });
    }

    handleChange(e) {
        var idactividad = e.target.value;
        var data = this.state.actividades_combo.filter(x => x.idactividad == idactividad).map(act => act.descripcion);

        this.setState({ selectact: data, selectidact: e.target.value });
    }

    handleSearch(event) {
        this.setState({ observacion: event.target.value });
        //console.log(this.state.observacion);
    }


    /////FUNCIONES para interactuar con los si/no de Materias
    handleHideClick_mat = (idactividad) => {
        let obj = this.state.fila_mat.find((o, i) => {
            if (o.idactividad === idactividad) {
                this.state.fila_mat[i].validacion = 'si'
                return this.state.fila_mat[i];
            }
        });
        if (obj == null) {
            this.state.fila_mat.push({
                idactividad: idactividad,
                validacion: 'si'
            })
        }
        if (this.state.expanded_mat.includes(idactividad)) {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== idactividad)
            }));
        }
        //console.log('MATERIA:' + this.state.fila_mat);

    }

    handleShowClick_mat = (idactividad) => {


        //console.log('MATERIA:' + idactividad)
        if (!this.state.expanded_mat.includes(idactividad)) {

            let obj = this.state.fila_mat.find((o, i) => {
                if (o.idactividad === idactividad) {
                    this.state.fila_mat[i].validacion = 'no'
                    return this.state.fila_mat[i];
                }
            });
            if (obj == null) {
                this.state.fila_mat.push({
                    idactividad: idactividad,
                    validacion: 'no'
                })
            }
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, idactividad]
            }));
        }
        //console.log(this.state.fila_mat);
    }

    handleHideAllClick_mat = () => {

        let filas = [];

        this.state.materias.forEach((element) => {
            filas.push({
                idactividad: element.idcurso,
                validacion: 'si'
            });
        })
        this.setState(() => ({
            expanded_mat: [],
            fila_mat: filas
        }));
        //console.log(this.state.expanded_mat);
        this.handleAllCheck_mat()
    }

    handleShowAllClick_mat = () => {

        let filas = [];
        let expandir = [];
        this.state.materias.forEach((element) => {
            filas.push({
                idactividad: element.idcurso,
                validacion: 'no'
            });
            if (!this.state.expanded_mat.includes(element.idcurso)) {
                expandir.push(element.idcurso);
            }
        })
        this.setState(() => ({
            expanded_mat: this.state.expanded_mat.concat(expandir),
            fila_mat: filas
        }));
        //console.log('MATERIA:' + this.state.fila_mat);
        //console.log('MATERIA:' + this.state.materias);
        this.handleAllCheck_mat()
    }

    handleAllCheck_mat() {
        //console.log('MATERIA:' + this.state.fila_mat);
        const check = document.getElementsByName("all_admi");
        const checkSin = document.getElementById("Materias_admi").getElementsByClassName('form-check-input');
        //console.log('MATERIA:' + check);
        //console.log('MATERIA:' + checkSin);
        if (check[0].checked) {
            //console.log('MATERIA:' + 'Siu');
            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "1") {
                    checkSin[i].checked = true;
                } else {
                    checkSin[i].checked = false;
                }
            }
        } else {

            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "0") {
                    //console.log('Nou');
                    checkSin[i].checked = true;
                } else {
                    checkSin[i].checked = false;
                }
            }
        }
    }


    onChangePao(event) {
        this.setState({
            periodo: event.target.value
        })
        //console.log(this.state.periodo)
    }

    handleNew(e) {
        var termino = this.state.periodo
        this.updatestate_mat(this.state.selectidact, this.state.selectact, this.state.observacion,  this.props.anio, this.state.periodo,0, 'Nueva Carga')

        this.cerrarModal()
    }
    renderMateriasTable(materias) {

        const columns_materias = [
            {
                dataField: 'id',
                text: '#',
                footer: '',

                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row, rowIndex) => {
                    return (
                        <div>
                            {rowIndex + 1}
                        </div>
                    )
                }
            },{
            dataField: 'idCurso',
                text: 'Codigo',
            hidden:true,
            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        }, {
            dataField: 'nombreMateria',
            text: 'Asignatura',
            headerStyle: color_head_desc('a'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        },
        {
            dataField: 'paralelo',
            text: 'Paralelo',
            headerStyle: color_head_desc('m'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        },
        {
            dataField: 'termino',
            text: 'Periodo',
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: PaoFormatter,
            footer: 'Subtotal:'
        },
        {
                dataField: 'anio',
                text: 'Anio',
                hidden:true,
        },
        {
            dataField: 'horasTotales',
            text: 'Horas',
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footerAlign: 'left',
            footer: columnData2 => {
                const total1 = columnData2.reduce((acc2, item2) => (Number(acc2) + Number(item2)).toFixed(2), 0);
                return (<>{total1.toLocaleString('en', { maximumFractionDigits: 2 })} horas</>);
            },
        } ];
         

        return (
            <BootstrapTable
                id='Materias_admi'
                keyField='idcurso'
                data={materias}
                columns={columns_materias}
                bordered={false} 
            />
        );

    }



    formatter = (valor) => {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: '2', minimumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    dateFormatter = (strFecha) => {
        var options = { year: 'numeric', month: '2-digit', day: 'numeric' };
        var dtFecha = new Date(strFecha);
        return dtFecha.toLocaleDateString("es-EC", options);
    }

    render() { 

        let contents_mat = this.state.loading2
            ? <p><em>Loading...</em></p>
            : this.renderMateriasTable(this.state.materias);


        const totalpepa = this.state.materias ? this.state.materias.map(horastot => horastot.horasTotales).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
       
        //const talambito = this.formatter(totalpepa);
        const talambito = totalpepa.toLocaleString('en', { maximumFractionDigits: 2 });

        const combo = {
            width: '150px',
        };
        const buttonToLink = {
            fontSize: '0.65em',
            textAlign: 'left',
            float: 'right',
            color: '#58A7E0',
            background: 'none',
            margin: 0,
            padding: 0,
            border: 'none',
            cursor: 'pointer',
            ":hover": {
                color: "yellow"
            }
        };
        const estilo = {
            color: 'white',
            fontSize: '15px',
            marginBottom: '20px',
            fontFamily: 'Robota'
        };
        return (
            <div> 
                {contents_mat}



                <div className="inline-grid  grid-cols-1 bg-total">
                    <div className="px-1 ">Total de Ambito de Admisiones: {talambito} horas</div>
                </div>

            </div>
        );
    }
     
     
    //OJO AQUi se usa la cedula 
    async populateMateriasData(idpersona, anio) {
        //const response = await fetch(API_URL + 'TblMateriasAdmi/' + idpersona + '/' + anio);
        //const respuesta = await response.json();
        const respuesta = this.props.cargaMat;
        const data = respuesta;
        this.setState({ materias: data, loading2: false });
        var selected = [];
        var actividades = [];
        if (data) {
            data.map(act => { selected.push({ idcurso: act.idcurso, validada: "", estado_actividad: "" }) })
            //data.map(act => { actividades.push({ ambito: 'MR', idactividad: act.idcurso, totalhoras: act.totalhoras, anio: act.anio, termino: act.termino}) })
            data.map(act => { actividades.push({ ambito: 'M|A', idactividad: act.idcurso }) })
            var actividades2 = [];
            data.map(act => { actividades2.push({ tipo: 'M|A', idactividad: act.idcurso, anio: act.anio, descripcion: act.nombremateria, periodo: act.termino, accion: '', observacion: '', totalhoras: act.horastotales,  validado: 1 }) })
            this.props.updateCarga(actividades, actividades2);
        }

        
        this.setState({ materia_elegida: selected, materias: data, loading: false });

    }



    async populateActividadesCombo(idpersona, anio) {
        const response = await fetch(API_URL+'TblActividades/' + anio + '/R/token');
        const respuesta = await response.json();
        const data = respuesta;
        this.setState({ actividades_combo: data, loading: false });
    }

}
